import toUnit from "./toUnit";
export default function responsivePropToUnit(value, unit) {
    if (value === null || typeof value !== "object") {
        return toUnit(value, unit);
    }
    return Object.fromEntries(Object.entries(value).map(([bp, v]) => [bp, toUnit(v, unit)]));
}
//# sourceMappingURL=responsivePropToUnit.js.map